import gql from "graphql-tag";

export const MY_TIMESHEET_APPROVE_TIMESHEETS_BY_CONTRACT = gql`
  mutation approveAllMysheetTimesheetsByContract($contract: String!) {
    approveAllMysheetTimesheetsByContract(contract: $contract)
  }
`;
